export default __webpack_public_path__ + "static/media/5bet_brand.1e13877b.png";